import {useState} from 'react'
import {getList} from '../features/layout/services/layout.service'
import {LayoutModel} from '../features/layout/models/layout.model'
import {
  getOccupancyTableList,
  getOccupancyTableReportList,
  getReportDayliTableList,
} from '../services/report.service'
import {ShowSnackBar} from '../../../util/functions'
export const useOccupancy = () => {
  const [layoutData, setLayoutData] = useState<LayoutModel[] | any>([])
  const [reportData, setReportData] = useState<LayoutModel[] | any>([])
  const [reportDayliData, setReporDaylitData] = useState<LayoutModel[] | any>([])
  const [TipoData, setTipoData] = useState<string>('')
  const [isLoading, setIsLoading] = useState(false)

  const getLayoutList = async (Dto: any) => {
    setIsLoading(true)
    try {

      const response = await getList(Dto)
      let data = response.data.data
      setTipoData(Dto.TipoData)
      setLayoutData(data || [])
      setIsLoading(false)
    } catch (error) {}
  }
  const getReportList = async (Dto: any) => {
    setIsLoading(true)
    try {
      const response = await getOccupancyTableList(Dto)
      let data = response.data
      setTipoData(Dto.TipoData)
      setReportData(data || [])
      setIsLoading(false)
    } catch (error) {}
  }
  const getReportListHuesped = async (Dto: any) => {
    setIsLoading(true)
    try {
      const response = await getOccupancyTableReportList(Dto)
      let data = response.data
      setTipoData('HUE')
      setReportData(data || [])
      setIsLoading(false)
    } catch (error) {}
  }
  const getReportDayliList = async (Dto: any) => {
    setIsLoading(true)
    try {
      const response = await getReportDayliTableList(Dto)
      if (!response.error) {
        let data = response.data
        setTipoData(Dto.TipoData)
        setReporDaylitData(data || [])
        setIsLoading(false)
      } else {
        setIsLoading(false)
        ShowSnackBar('Error de sistema', 'error')
      }
    } catch (error) {}
  }
  const getReportDayListHuesped = async (Dto: any) => {
    setIsLoading(true)
    try {
      const response = await getOccupancyTableReportList(Dto)
      let data = response.data
      setTipoData('HUE')
      setReporDaylitData(data || [])
      setIsLoading(false)
    } catch (error) {}
  }

  return {
    isLoading,
    layoutData,
    reportData,
    TipoData,
    reportDayliData,
    setTipoData,
    getLayoutList,
    setLayoutData,
    setReportData,
    getReportList,
    getReportListHuesped,
    getReportDayliList,
    getReportDayListHuesped,
  }
}
